// プライバシーポリシー本文データ（/privacy-policy で表示）
export const privacyPolicyMeta = {
  label: 'Privacy Policy',
  title: ['プライバシー', 'ポリシー'],
  lead: [
    [
      '株式会社SALT2（以下「当社」といいます。）は、当社が提供するコンテンツ管理・配信サービス' +
        '（以下「本サービス」といいます。）および当社が salt-2.com ドメイン（そのサブドメインを含みます。）で' +
        '運営するウェブサイト（以下「当社サイト」といいます。）' +
        'における情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます。）を定めます。',
    ],
  ],
};

export const privacyPolicyArticles = [
  {
    no: '第1条',
    title: '適用範囲',
    body: [
      '本ポリシーは、本サービスの利用および本サービスと外部サービスとの連携に伴い、当社が取り扱う情報に適用されます。',
      '当社サイトの閲覧、ならびに当社サイトからのお問い合わせ、資料請求、受講申請および当社が運営するコミュニティ「LOCKED IN」への応募に伴い当社が取り扱う情報については、第8条および第9条を適用するほか、第2条、第10条以降の規定を適用します。',
    ],
  },
  {
    no: '第2条',
    title: '個人情報等',
    body: [
      '本ポリシーにおける「個人情報」とは、個人情報の保護に関する法律に定める個人情報をいいます。',
      '当社は、本サービスの提供および運用に必要な範囲で、個人情報のほか、アカウント情報、認証情報、投稿コンテンツおよびシステムログ等を取り扱う場合があります。',
    ],
  },
  {
    no: '第3条',
    title: '取り扱う情報',
    body: [
      '当社は、本サービスにおいて、以下の情報を取り扱う場合があります。',
      {
        list: [
          '連携する外部サービスのアカウント識別情報、表示名、プロフィール画像その他の基本情報',
          '外部サービスとの認証に必要なアクセストークン、リフレッシュトークン、認可された権限、有効期限その他の認証情報',
          '配信対象となる動画、画像、音声、文章、タイトル、説明文、ハッシュタグ、公開設定その他のコンテンツ情報',
          '配信日時、配信結果、処理状況、操作履歴、エラー情報その他のシステムログ',
          'IPアドレス、ブラウザ、端末、アクセス日時その他、本サービスの運用およびセキュリティ管理に必要な技術情報',
        ],
      },
    ],
  },
  {
    no: '第4条',
    title: '情報の取得方法',
    body: [
      '当社は、以下の方法により情報を取得します。',
      {
        list: [
          '利用者が本サービスに入力、登録またはアップロードする方法',
          '利用者が外部サービスとの連携を許可したことにより、当該外部サービスから取得する方法',
          '本サービスの利用に伴い、システム上で自動的に記録する方法',
        ],
      },
    ],
  },
  {
    no: '第5条',
    title: '利用目的',
    body: [
      '当社は、取り扱う情報を以下の目的で利用します。',
      {
        list: [
          '本サービスの提供および運営',
          '外部サービスとの認証およびアカウント連携',
          'コンテンツのアップロード、配信および公開',
          '配信先、配信内容、配信結果および処理状況の確認',
          '本サービスに関する連絡、保守、障害対応および機能改善',
          '不正利用の防止、本人確認およびセキュリティの確保',
          '外部サービスの利用規約、ガイドラインおよび適用法令の遵守',
          '前各号に付随する目的',
        ],
      },
    ],
  },
  {
    no: '第6条',
    title: '利用目的の変更',
    body: [
      '当社は、変更前の利用目的と合理的な関連性を有すると認められる範囲で、利用目的を変更する場合があります。',
      '利用目的を変更した場合、当社は、変更後の利用目的を当社ウェブサイトまたは本サービス上で公表します。',
    ],
  },
  {
    no: '第7条',
    title: '外部サービスへの情報送信',
    body: [
      '当社は、本サービスの機能を提供するため、利用者が指定したコンテンツ、配信設定および認証に必要な情報を、連携先となる外部サービスへ送信する場合があります。',
      '外部サービスにおける情報の取扱いについては、当該外部サービスが定める利用規約、プライバシーポリシーその他の規定が適用されます。',
    ],
  },
  {
    no: '第8条',
    title: '当社サイトにおける情報の取扱い',
    body: [
      '当社は、当社サイトにおいて、以下の情報を取り扱う場合があります。',
      {
        list: [
          'お問い合わせフォーム、資料請求フォーム、受講申請フォームまたはコミュニティ「LOCKED IN」の応募フォームに入力された氏名、フリガナ、年齢、メールアドレス、電話番号、会社名・部署・役職その他の所属、学年または経験年数、開発経験、SNSその他のウェブサイトのリンク、プログラムやコミュニティを知った経路および紹介者、ご関心のある内容、参加を希望する場、現在取り組んでいることその他の情報',
          '当社サイトへの流入元に関する情報（参照元のURL、リンクに付与されたキャンペーン識別子、最初に閲覧したページおよびその日時）',
          '閲覧したページ、閲覧日時、利用端末およびブラウザの種類、IPアドレスその他の当社サイトの閲覧に関する情報',
        ],
      },
      '前項第2号の情報は、利用者の端末のブラウザ内に保存され、利用者が受講申請を送信した場合に限り、申請内容とあわせて当社に送信されます。ブラウザに保存された情報は、ブラウザの設定から当社サイトのデータを削除することにより消去できます。',
      '当社は、前各項の情報を、お問い合わせへの回答、資料の提供および当社のサービスに関するご案内、受講申請の選考および連絡、プログラムの運営、コミュニティ「LOCKED IN」への応募内容の確認、参加いただく方の選考およびご連絡、コミュニティの運営、広報活動の効果測定ならびに当社サイトの改善のために利用します。',
    ],
  },
  {
    no: '第9条',
    title: 'アクセス解析ツールの利用',
    body: [
      '当社は、当社サイトの一部において、利用状況の把握、広報活動の効果測定および当社サイトの改善のため、Google LLCが提供する「Google アナリティクス」およびMicrosoft Corporationが提供する「Microsoft Clarity」を利用しています。これらのツールは、Cookieその他の技術を用いて、閲覧したページ、流入元、利用端末等の情報を収集します。当社は、これらのツールに氏名、メールアドレスその他の特定の個人を識別できる情報を送信しません。',
      '収集された情報は、各提供者のプライバシーポリシーに基づいて管理されます。利用者は、ブラウザの設定でCookieを無効にすることにより、これらのツールによる情報の収集を停止できます。',
    ],
  },
  {
    no: '第10条',
    title: '第三者提供',
    body: [
      '当社は、以下の場合を除き、あらかじめ本人の同意を得ることなく、個人情報を第三者に提供しません。',
      {
        list: [
          '法令に基づく場合',
          '人の生命、身体または財産の保護に必要であり、本人の同意を得ることが困難な場合',
          '公衆衛生の向上または児童の健全な育成のために特に必要であり、本人の同意を得ることが困難な場合',
          '国の機関、地方公共団体またはその委託を受けた者が法令上の事務を遂行することに協力する必要があり、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合',
          'その他、法令により認められる場合',
        ],
      },
      '利用目的の達成に必要な範囲で業務を委託する場合、合併その他の事由による事業承継に伴い情報を提供する場合その他法令上第三者提供に該当しない場合については、前項を適用しません。',
    ],
  },
  {
    no: '第11条',
    title: '業務委託',
    body: [
      '当社は、本サービスの運用、サーバー管理、データ保管、保守またはセキュリティ対応等の業務を外部事業者へ委託する場合があります。',
      'この場合、当社は委託先を適切に選定し、必要な契約を締結するとともに、適切な監督を行います。',
    ],
  },
  {
    no: '第12条',
    title: '安全管理措置',
    body: [
      '当社は、取り扱う情報への不正アクセス、漏えい、紛失、改ざんおよび不正利用を防止するため、アクセス権限の制限、認証情報の適切な保管、通信の暗号化、ログ管理その他の合理的な安全管理措置を講じます。',
      '安全管理措置の詳細については、本人からの求めに応じて、法令上開示が適切である範囲で回答します。',
    ],
  },
  {
    no: '第13条',
    title: '保存期間および削除',
    body: [
      '当社は、取り扱う情報を、本サービスの提供および利用目的の達成に必要な期間に限り保存します。',
      '外部サービスとの連携が解除された場合、本サービスの利用が終了した場合、または情報を保有する必要がなくなった場合、法令上保存が必要な情報を除き、認証情報および関連データを合理的な期間内に削除または利用できない状態にします。',
    ],
  },
  {
    no: '第14条',
    title: '開示、訂正、利用停止等',
    body: [
      '本人は、当社が保有する自己の個人情報について、法令に基づき、開示、訂正、追加、削除、利用停止、消去または第三者提供の停止を請求できます。',
      '当社は、本人確認を行った上で、法令に従い合理的な期間内に対応します。法令上請求に応じる義務がない場合、または本人もしくは第三者の権利利益、当社業務の適正な実施等に重大な影響を及ぼすおそれがある場合は、請求の全部または一部に応じないことがあります。',
    ],
  },
  {
    no: '第15条',
    title: '本ポリシーの変更',
    body: [
      '当社は、法令、本サービスの内容、外部サービスの仕様または情報の取扱方法の変更等に応じて、本ポリシーを変更する場合があります。',
      '変更後の本ポリシーは、当社ウェブサイトまたは本サービス上に掲載した時点から効力を生じます。ただし、法令上別途の手続が必要な場合は、その手続に従います。',
    ],
  },
];

export const privacyPolicyContact = {
  intro: '本ポリシーに関するお問い合わせは、以下の窓口までお願いいたします。',
  operator: '株式会社SALT2',
  representative: '代表取締役　鬼澤 輔',
  address: '〒106-0041 東京都港区麻布台1丁目8-10 麻布偕成ビル3階',
  email: 'info@salt-2.com', // 問い合わせ窓口の共通アドレス（2026-10-18 代表指示。代表個人のアドレスは載せない）
  website: 'https://salt-2.com/',
};

export const privacyPolicyEstablishedDate = '2026年8月17日';

export const privacyPolicyRevisedDate = '2026年10月18日';
